/* ------------------------------------------- */
/*   Error handler
/*   Flickr API error spec: https://www.flickr.com/services/api/flickr.photos.search.html
/* ------------------------------------------- */
import { history } from 'AppSrc/core/components/router/history';

const UNAUTHORIZED_STATUS = 401;

// handle server errors with response codes other than 200 properly identified as errors
const handleError = (error) => {

  const formattedError = {
    code: 0,
    message: 'Error fetching data from server.',
  };

  // if error hidden in a response with status 200
  if (error.code) {
    formattedError.code = error.code;
    if (error.message) {
      formattedError.message = error.message;
    }
  }
  // proper API error
  else if (error.response && error.response.status) {
    formattedError.code = error.response.status;
    formattedError.message = error.response.data;
    if (error.response.message) {
      formattedError.message = error.response.message;
    }
  }

  if (formattedError.code === UNAUTHORIZED_STATUS) {
    // redirect the user to the token_expired page
    // the page component will log the user out
    history.push('/token_expired');
  }
  // throw the error so it gets caught in redux thunk action
  // throw formattedError, formattedError;
  console.warn('handleError', formattedError);
  return Promise.reject(formattedError);
};


// catch errors hidden in a response with status 200
const catchHiddenError = (response) => {

  if (response.data.stat === 'fail' && response.data.code) {

    console.warn('catchHiddenError', response.data);
    // throw an error that the regular error handler will catch
    // throw response.data;
    return Promise.reject(response.data);
  }

  // return a resolved promise (the status 200 is genuine success)
  return Promise.resolve(response);
  // return response;
};


export {
  catchHiddenError,
  handleError,
};
